import { PREFIX } from "../core";

export const BuiltIn_DISAPPEAR_ANIMATE_NAME = `${PREFIX}_BuiltIn_CallBack_Disappear`;

export var RenderStateEnum;

!function(RenderStateEnum) {
    RenderStateEnum.render = "render", RenderStateEnum.disappear = "disappear";
}(RenderStateEnum || (RenderStateEnum = {}));
//# sourceMappingURL=animate.js.map